import { Address, defaultAddress } from '../contacts/address';
import { PhoneNumber, defaultPhoneNumber } from '../contacts/phoneNumber';
import { SimpleObject } from '../app';
import { CompanyFile } from './companyFile';
import { RequestBase, ResponseBase } from '../Base';
import { defaultPaging } from '../common/paging';

export interface CreateCompanyRequest {
    name: string; type: string; 
    email?: string; 
    claimEmail?: string; 
    phoneNumbers: PhoneNumber[]; 
    mailingAddress: Address; 
    assignedRep?: SimpleObject; 
    xaIsBusinessUnit?: boolean; 
    xaCompanyName?: string; 
}

export interface Company extends CreateCompanyRequest {
    companyId: number;     
    isActive: boolean;     
    // Metrics
    activeClaimCount?: number;
    ytdOpenClaims?: number;
    ytdClosedClaims?: number;
    lifetimeClaimCount?: number;
    lastClaimDate?: string;    
    companyFiles?: CompanyFile[];
}

export interface CompaniesRequest extends RequestBase {
    type: 'All' | 'Adjuster' | 'Agent' | 'IndependentAdjuster' | 'Insurance' | 'Mortgage'; 
    activeOnly: boolean; 
    activeStatus: 'all' | 'active' | 'inactive';
    name?: string;
    assignedRepId?: number;
    hasActiveClaims?: boolean | string;
    hasLifetimeClaims?: boolean | string;
    lastClaimDateStart?: string; 
    lastClaimDateEnd?: string;
}

export const defaultCompanyRequest: CompaniesRequest = {
    ...defaultPaging,
    type: 'All',
    activeOnly: true, // here for legacy searches, refactor them to use actiaveSatus and remove this field
    activeStatus: 'active',    
}

export interface CompanySummary {
    companyId: number; 
    name: string; 
    isActive: boolean; 
    type: string; 
    email: string; 
    claimEmail: string; 
    phoneNumbers: PhoneNumber[]; 
    mailingAddress: Address; 
    assignedRep?: string; 
    activeClaimCount?: number;
    ytdOpenClaims?: number;
    ytdClosedClaims?: number;
    lifetimeClaimCount?: number;
    lastClaimDate?: string;
    xaIsBusinessUnit?: boolean; 
    xaCompanyName?: string; 
}

export interface CompaniesResponse extends ResponseBase<CompanySummary> { }

export const defaultCompany: Company = {
    companyId: 0,
    name: '', 
    isActive: false, 
    type: '', 
    email: '', 
    claimEmail: '',    
    phoneNumbers: [defaultPhoneNumber],
    mailingAddress: defaultAddress,
}
